import { createContext } from 'react';

export const RevampContext = createContext({
  isRevamp: false,
});
